/**
 * Chrome ignores the `download` attribute on cross-origin links, so user files on the
 * *userdata*.presonusmusic.com hosts open in the media player instead of downloading.
 * The `download` param makes a Cloudflare rule on those hosts respond with
 * `Content-Disposition: attachment` (DENG-900). Pre-signed URLs are left alone because an
 * extra query param would invalidate the signature.
 */
export function withDownloadParam(url: string): string {
  if (!url || url.includes("X-Amz-Signature=")) return url;
  return url + (url.includes("?") ? "&" : "?") + "download=1";
}

export function triggerFileDownload(url: string, filename?: string) {
  if (!url) return;
  const link = document.createElement("a");
  link.href = withDownloadParam(url);
  link.download = filename || "";
  link.click();
}
